import { render, staticRenderFns } from "./AddEpisodeShareTab.vue?vue&type=template&id=060b5f17&"
import script from "./AddEpisodeShareTab.vue?vue&type=script&lang=js&"
export * from "./AddEpisodeShareTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports